import { useQueryLead } from "libs/api/src/lib/hooks/lead/useQueryLead";

import useGymflowModels from "../../store";
import { Spinner } from "../atoms";
import { LeadEmailForm } from "./LeadProfile/LeadEmailForm";
import { LeadForm } from "./LeadProfile/LeadForm";
import { LeadMarketingOptionsForm } from "./LeadProfile/LeadMarketingOptionsForm";
import { SettingsSection } from "./SettingsSection";

function LeadDetailsForm({ leadId }: { leadId: number }) {
  const { api } = useGymflowModels();
  const { isLoading } = useQueryLead({ api, leadId });
  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div className="-mx-4 flex max-h-full flex-col overflow-y-auto px-4 lg:-mx-8 lg:px-8">
      <div className="relative flex size-full max-h-full flex-col">
        <div className="-mt-4 flex flex-col pb-48">
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title="Account"
              subTitle="Setup or update the users account"
            />
            <SettingsSection.Content>
              <LeadEmailForm leadId={leadId} />
            </SettingsSection.Content>
          </SettingsSection.Container>
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title="Profile Information"
              subTitle="Update the users basic information."
            />
            <SettingsSection.Content>
              <LeadForm leadId={leadId} />
            </SettingsSection.Content>
          </SettingsSection.Container>
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title="Notifications"
              subTitle="Set the users notification preferences."
            />
            <SettingsSection.Content>
              <LeadMarketingOptionsForm leadId={leadId} />
            </SettingsSection.Content>
          </SettingsSection.Container>
        </div>
      </div>
    </div>
  );
}

export default LeadDetailsForm;
